import React from "react";
import {useState} from "react";

import courses from "./coursesJSON.json"

function CoursesPage(){
    const [state, setState] = useState();
    const test=(e)=>{
        // console.log("option changed...")
        setState(e.target.value);
    }
    return(
        <>
            <div className="container courses-height">
                <div className="row">
                    <h1 className="text-center mt-4 mb-3 headingCls">Courses we offer</h1>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                        <div className="mb-3">
                            {/* <label className="form-label fs-4">Search Course</label>
                            <input type="text" className="form-control bg-secondary fw-bold text-light text-center" onChange={test} value={state}/> */}
                            <select className="form-select font-monospace fw-bold fs-4 border border-dark rounded-pill ps-5" value={state} onChange={test}>
                                <option value="dummy"></option>
                                <option className="font-monospace fw-bold" value="">All Courses</option>
                                <option className="font-monospace fw-bold">Computer Science</option>
                                <option className="font-monospace fw-bold">Electronics</option>
                                <option className="font-monospace fw-bold">Mechanical</option>
                                <option className="font-monospace fw-bold">Info. Technology</option>
                                <option className="font-monospace fw-bold">Electrical</option>
                                <option className="font-monospace fw-bold">Civil</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
                <div className="row mb-3 mt-3">
                    {courses.filter(x=>x.title.includes(state)).map((course)=>{
                        return(
                            <div className="col-lg-4 mb-3">
                                <div className={`card pb-3 bg-secondary-subtle border border-top border-end-0 border-bottom-0 border-start-0 border-5 ${course.borderTop}`}>
                                    <img src={course.pic} className="card-img-top" alt="..."/>
                                    <div className="card-body text-center">
                                    <h5 className="card-title fs-2 mb-3 cardHead">{course.title}</h5><hr/>
                                    <p className="card-text text-start text-muted fw-semibold my-4 aboutText">{course.description}</p>
                                    <a href={course.link} target="__block" className="linkCls fs-4">More Info</a>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}export default CoursesPage